import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ReactRouterPropTypes from "react-router-prop-types";

import Logo from "./Logo";
// import LoggedInMenu from "./header/LoggedInMenu";
// import LoggedOutMenu from "./header/LoggedOutMenu";

// const SERVER_URL = process.env.REACT_APP_API_URL;

class Header extends React.Component {
    constructor() {
        super();

        this.state = {
            open: false
        };
    }

    toggleOpen = () => {
        this.setState(state => ({
            open: !state.open
        }));
    };

    closeHeaderMenu = () => {
        this.setState({ open: false });
    };

    checkFocus = event => {
        const related = event.relatedTarget;
        if (this.state.open && related == null) {
            this.toggleOpen();
            return true;
        }

        const parent = document.querySelector(".header__menu");
        if (!parent.contains(related)) {
            this.closeHeaderMenu();
            return true;
        }
    };

    render() {
        /*
        const logoutUrl = this.props.match.params.channel
            ? `${SERVER_URL}/logout?c=${this.props.match.params.channel}`
            : `${SERVER_URL}/logout`;
        const path = this.props.match.path;
        */
        const { /* authenticated, */ hideLogo } = this.props;

        return (
            <header className="header">
                {!hideLogo && (
                    <a href="/" className="logo--link">
                        <Logo showMobile={true} />
                    </a>
                )}
            </header>
        );
    }
}

Header.propTypes = {
    teamId: PropTypes.string,
    userId: PropTypes.string,
    channelId: PropTypes.string,
    match: ReactRouterPropTypes.match,
    dataDeleted: PropTypes.bool,
    hideLogo: PropTypes.bool,
    authenticated: PropTypes.bool
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx